( () => {

	const allFilterForms = document.querySelectorAll<HTMLFormElement>( 'form[data-ufr-advanced-filter]' );

	allFilterForms.forEach( ( filterFormElement ) => {

		const filterWrapper = filterFormElement.querySelector<HTMLElement>( '[data-ufr-filters-for-pills]' );
		const alphabeticalFilterWrapper = filterFormElement.querySelector<HTMLElement>(
			'div[data-ufr-alphabetical-filter]' );
		const pillsWrapper = filterFormElement.querySelector<HTMLElement>( '[data-ufr-pills-for-filters]' );
		const emptyPill = pillsWrapper.querySelector<HTMLDivElement>( 'div[data-ufr-pill-template]' );

		const advancedFilters = filterWrapper.querySelectorAll<HTMLInputElement>(
			'input[type="checkbox"]' );
		const alphabeticalFilters = alphabeticalFilterWrapper?.querySelectorAll<HTMLInputElement>(
			'input[type="checkbox"]' );

		/**
		 * Add a pill component to pillsWrapper.
		 * Call this function whenever a filter checkbox is toggled on.
		 *
		 * @param filterCheckbox The filterCheckbox that changed its value
		 */
		const addPill = ( filterCheckbox: HTMLInputElement ) => {
			const newPill = emptyPill.cloneNode( true ) as HTMLDivElement;
			const pillTextSpan = newPill?.firstElementChild as HTMLSpanElement;
			const pillDeleteLabel = newPill?.lastElementChild as HTMLLabelElement;
			const pillDeleteButton = pillDeleteLabel?.firstElementChild as HTMLButtonElement;

			if ( !newPill ) return;

			// Get the label text that should be placed inside the pill
			const filterLabel = filterCheckbox.labels[0]?.textContent ?? '';

			newPill.removeAttribute( 'data-ufr-pill-template' );
			newPill.setAttribute( 'data-for', filterCheckbox.id );
			pillDeleteLabel.setAttribute( 'for', filterCheckbox.id );

			newPill.classList.remove( 'hidden' );
			newPill.classList.add( 'flex' );

			pillTextSpan.textContent = filterLabel;
			pillsWrapper.appendChild( newPill );


			pillDeleteButton.addEventListener( 'click', () => {
				// Untoggle the checkbox
				filterCheckbox.checked = false;

				// We need to dispatch this event manually here
				// because filterCheckbox is placed inside a dropdown that implicitly is
				// in an "inert" state when the pillDeleteButton is clicked.
				filterCheckbox.dispatchEvent( new InputEvent( 'change', { bubbles: true } ) );
				filterCheckbox.dispatchEvent( new InputEvent( 'input', { bubbles: true } ) );
			} );
		};

		/**
		 * Remove a pill component from pillsWrapper.
		 * Call this function whenever a filter checkbox is toggled off.
		 *
		 * @param filterCheckbox The filterCheckbox that changed its value
		 */
		const removePill = ( filterCheckbox: HTMLInputElement ) => {
			const foundPills = pillsWrapper.querySelectorAll<HTMLElement>( `div[data-for="${filterCheckbox.id}"]` );
			foundPills.forEach( ( pillElement ) => {
				pillElement.remove();
			} );
		};

		const filterCheckboxHandler = ( filterCheckbox ) => {
			filterCheckbox.addEventListener( 'input', ( event ) => {
				if ( filterCheckbox.checked ) {
					addPill( filterCheckbox );
				} else {
					removePill( filterCheckbox );
				}
			} );
		};

		// Add event listeners that handle the pill addition and removal for all
		// filter checkboxes
		advancedFilters.forEach( filterCheckboxHandler );
		alphabeticalFilters?.forEach( filterCheckboxHandler );

		alphabeticalFilters?.forEach( ( currentCheckbox ) => {
			currentCheckbox.addEventListener( 'input', () => {
				if( currentCheckbox.checked ) {
					alphabeticalFilters.forEach( ( manipulatedCheckbox ) => {
						if ( manipulatedCheckbox === currentCheckbox ) return;
						manipulatedCheckbox.checked = false;

						// We need to dispatch this event manually here because the
						// manipulatedCheckbox had no user interaction, so for security
						// reasons most browsers prevent automatic dispatching of events.
						manipulatedCheckbox.dispatchEvent( new InputEvent( 'input' ) );
					} );
				}
			} );
		} );

	} );

} )();
